import {RetailPrice} from "../accounting/Purchasable";
import {Performanceable} from "../accounting/Performanceable";
import {makeSensitive, Sensitive} from "../common/Sensitive";
import {Money} from "../accounting/Finance";
import {TimeRetailPricePerHour, TimeRetailPricePerHourType} from "./TimeRetailPricePerHourType";


export interface ProjectBillType {
    type: string
}

export function projectBillTypes(): ProjectBillType[] {
    return [
        ProjectNoneInvoiceItem,
        ProjectSingleInvoiceFlatItem,
        ProjectSingleInvoiceTimeItem,
        ProjectPartialInvoiceItem
    ];
}

export const ProjectNoneInvoiceItem: ProjectBillType = {
    type: "none"
}


export interface ProjectPartialInvoiceBillType extends ProjectBillType, RetailPrice, Performanceable {}

export const ProjectPartialInvoiceItem: ProjectPartialInvoiceBillType = {
    type: "partial_invoice",
    retailPrice: makeSensitive( 0 ),
    performance: 0
}

export function isPartialInvoiceBillType( obj: ProjectBillType ):obj is ProjectPartialInvoiceBillType {
    return obj.type === ProjectPartialInvoiceItem.type
}

export interface ProjectSingleInvoiceFlatBillType extends ProjectBillType, RetailPrice {}

export const ProjectSingleInvoiceFlatItem: ProjectSingleInvoiceFlatBillType = {
    type: "single_invoice_flat",
    retailPrice: makeSensitive( 0 )
}

export function isSingleInvoiceFlatBillType( obj: ProjectBillType ):obj is ProjectSingleInvoiceFlatBillType {
    return obj.type === ProjectSingleInvoiceFlatItem.type
}

export interface ProjectSingleInvoiceTimeBillType extends ProjectBillType {
    flatRetailPricePerHour: Sensitive<Money>
    timeRetailPricePerHourType: TimeRetailPricePerHourType
}

export const ProjectSingleInvoiceTimeItem: ProjectSingleInvoiceTimeBillType = {
    type: "single_invoice_time",
    flatRetailPricePerHour: makeSensitive( 0 ),
    timeRetailPricePerHourType: TimeRetailPricePerHour.roleBased

}

export function isSingleInvoiceTimeBillType( obj: ProjectBillType ):obj is ProjectSingleInvoiceTimeBillType {
    return obj.type === ProjectSingleInvoiceTimeItem.type
}




